import React from 'react';
import ModuleCollectionRenderer from '../shared/ModuleCollectionRenderer/ModuleCollectionRenderer';
import { PageSectionProps } from './types';
import { ModuleList } from 'utils/modules';
import { NinetailedMode } from 'types/constants';

/**
 * Renders a page section
 * @param modulesCollection - The modules collection to render within the section
 * @returns The rendered component
 */
const PageSection = (props: PageSectionProps & { ninetailedMode?: NinetailedMode; enrollmentUrl: string }) => {
  return (
    <div data-testid="pageSection">
      <ModuleCollectionRenderer
        {...props}
        allowedModules={ModuleList.MAIN}
        ninetailedMode={props.ninetailedMode}
        enrollmentUrl={props.enrollmentUrl}
      />
    </div>
  );
};

export default PageSection;
